import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Subscription } from 'rxjs';
import { Iso2To3 } from '../../../../assets/i18n/languages/iso2to3';
import { LocaleService } from '../../../services/locale.service';

@Pipe({
  name: 'languageCodeToName',
  pure: false,
})
export class LanguageCodeToNamePipe implements PipeTransform, OnDestroy {
  private readonly localeService = inject(LocaleService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly subscriptions = new Subscription();
  private languages: Record<string, string> = {};
  private countries: Record<string, string> = {};

  constructor() {
    // FIXME This type hack is needed because instant/stream must return a string but in this case it returns an object (wtf)
    this.subscriptions.add(
      this.localeService.stream('languages').subscribe((languages) => {
        this.languages = languages as unknown as Record<string, string>;
        this.changeDetectorRef.markForCheck();
      })
    );
    this.subscriptions.add(
      this.localeService.stream('countries').subscribe((countries) => {
        this.countries = countries as unknown as Record<string, string>;
        this.changeDetectorRef.markForCheck();
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  transform(locale: string): string {
    const [languageCode, countryCode] = locale.split('-')
    const iso3Code = this.buildIso3Code(languageCode);
    const languageName = this.languages[iso3Code] ?? iso3Code

    if (!countryCode) {
      return languageName;
    }

    const countryName = this.countries[countryCode] ?? countryCode

    return `${languageName} (${countryName})`;
  }

  buildIso3Code(languageCode: string): string {
    if (languageCode.length === 2) {
      return Iso2To3[languageCode] ?? languageCode;
    }

    return languageCode
  }
}
